<!-- // download section \\ -->
<section class="download-section edit">
  <div class="comman-width">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <h2>{{ secondBrandName }} now available on Apple and Android</h2>

        <span>Download our FREE top rated App</span>

        <img class="gap app" src="assets/images/app-store.png" />

        <img class="app" src="assets/images/play-store.png" />

        <span class="get">or get the download link</span>

        <form class="{{ sendmessageClass }}">
          <input
            type="text"
            class="form-control"
            name="mno_p"
            [(ngModel)]="sendno"
            placeholder="Enter your mobile number"
            (keypress)="removemsgerr($event)"
            (focus)="removemsgerr($event)"
          />
          <button
            type="submit"
            class="btn btn-hover-effect"
            (click)="sendmsg(sendno, '')"
          >
            <div class="insider"></div>
            Get Download Link
          </button>
          <span>{{ sendmessageStatus }}</span>
        </form>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <img src="assets/images/phone.png" class="img-responsive iphone" />
      </div>
    </div>
  </div>
</section>
<!-- \\ download section // -->

<!-- // lowest section \\ -->
<!-- <section class="lowest-section edit">
  <div class="comman-width">
    <app-search></app-search>
  </div>
</section> -->
<!-- \\ download section // -->

<!-- // discount section \\ -->
<section class="discount-section">
  <div class="comman-width">
    <h2>How {{ brandName }} Works</h2>
    <div class="d-flex">
    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 gap">
      <div class="repeat">
        <img src="assets/images/pharmacy-near.png" alt="pharmacy-near" />
        <span class="line">&nbsp;</span><span class="oval">&nbsp;</span>
        <h3>Find your pharmacy near you</h3>
        <p>
          On behalf of consumers nationwide, {{ brandName }} has negotiated a
          discount rate with a national network of drugstores and retail
          outlets.
        </p>
      </div>
      <div class="repeat">
        <img src="assets/images/lowest-price.png" alt="pharmacy-near" />
        <h3>Find the lowest price</h3>
        <p>
          On behalf of consumers nationwide, {{ brandName }} has negotiated a
          discount rate with a national network of drugstores and retail
          outlets.
        </p>
      </div>
    </div>

    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 m-d-none">
      <img
        src="assets/images/how-it-works.png"
        class="img-responsive pharmacy"
        alt="pharmacy-near"
      />
    </div>

    <div class="col-lg-4 gap text-right col-md-4 col-sm-12 col-xs-12">
      <div class="repeat">
        <img src="assets/images/discount-card.png" alt="pharmacy-near" />
        <h3>Get your discount card</h3>
        <p>
          On behalf of consumers nationwide, {{ brandName }} has negotiated a
          discount rate with a national network of drugstores and retail
          outlets.
        </p>
      </div>
      <div class="repeat">
        <img src="assets/images/search-drug.png" alt="pharmacy-near" />
        <h3>Search for any drug</h3>
        <p>
          On behalf of consumers nationwide, {{ brandName }} has negotiated a
          discount rate with a national network of drugstores and retail
          outlets.
        </p>
      </div>
    </div>

    </div>
  </div>
</section>
<!-- \\ discount section // -->

<!-- // behalf section \\ -->
<section class="behalf-section">
<div class="blue_download">
  <h2>What will you get</h2>

  <p>
    On behalf of consumers nationwide, {{ brandName }} has negotiated a discount
    rate with a national network of drugstores and retail outlets. Approximately 35,000 pharmacies stores have partnered with {{ brandName }} to offer prescription
    assistance to the uninsured and under-insured.
  </p>

  <ngx-slick-carousel
    class="carousel"
    #slickModal="slick-carousel"
    [config]="slideConfig"
  >
    <div ngxSlickItem *ngFor="let slide of slides" class="slide">
      <div class="">
        <div class="image">
          <img src="{{ slide.icon }}" />
        </div>
        <span>{{ slide.heading }}</span>
      </div>
    </div>
  </ngx-slick-carousel>
</div>
</section>
<!-- \\ behalf section // -->

<!-- // review section \\ -->
<!-- <section class="review-section">
  <div class="comman-width">
    <h2><span>App Reviews</span></h2>
    <ngx-slick-carousel
      class="carousel"
      #slickModal="slick-carousel"
      [config]="slideConfig2"
    >
      <div ngxSlickItem *ngFor="let slide2 of slides2" class="slide">
        <div class="bg">
          <p>{{ slide2.text }}</p>
          <span>{{ slide2.heading }}</span>
          <div class="ratingTag">
            <span>{{slide2.rating}}</span>
            <ul class="star">
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
        </div>
      </div>
    </ngx-slick-carousel>
  </div>
</section> -->
<!-- \\ review section // -->

<!-- // download section \\ -->
<section class="download-section edit change available">
  <div class="comman-width">
    <div class="row">
      <div class="col-lg-12">
        <h2>{{ secondBrandName }} now available on Apple and Android</h2>

        <span>Download our FREE top rated App</span>

        <img class="gap" src="assets/images/app-store.png" />

        <img src="assets/images/play-store.png" />

        <span class="get">or get the download link</span>

        <form class="{{ sendmessageClass }}">
          <input
            type="text"
            class="form-control differ"
            [(ngModel)]="sendno"
            name="mno"
            placeholder="Enter your mobile number"
            (keypress)="removemsgerr($event)"
            (focus)="removemsgerr($event)"
          />
          <button
            type="submit"
            class="btn btn-hover-effect"
            (click)="sendmsg(sendno, 'downloadbottom')"
          >
            <div class="insider"></div>
            Get Download Link
          </button>
          <span>{{ sendmessageStatus }}</span>
        </form>
      </div>
    </div>
  </div>
</section>
<!-- \\ download section // -->
<!-- <app-getcard></app-getcard> -->
